import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { RatingsSectionProps, RatingsData } from "./types";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface ParticipationDropRatingsVoterSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsVoterSection(t0) {
  const $ = _c(16);
  const {
    drop,
    theme,
    ratingsData
  } = t0;
  const {
    hasRaters
  } = ratingsData;
  let t1;
  if ($[0] !== drop.raters_count || $[1] !== drop.top_raters || $[2] !== drop.wave || $[3] !== hasRaters || $[4] !== theme.ring || $[5] !== theme.text) {
    t1 = hasRaters && <div className="tw-flex tw-items-center -tw-space-x-1.5">{drop.top_raters.slice(0, 5).map((rater, index) => <div key={rater.profile.id}><div className="tw-relative tw-transition-transform hover:tw-scale-110 hover:tw-z-10" style={{
          zIndex: drop.top_raters.length - index
        }} data-tooltip-id={`participation-rater-${rater.profile.id}`}>{rater.profile.pfp && <Link href={`/${rater.profile.handle}`}><img src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${rater.profile.handle}'s avatar`} className={`tw-h-5 tw-w-5 tw-rounded-md tw-ring-1 tw-object-cover ${theme.ring} tw-bg-iron-900`} /></Link>}</div><Tooltip id={`participation-rater-${rater.profile.id}`} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px"
        }}>{rater.profile.handle} • {formatNumberWithCommas(rater.rating)}{" "}{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</Tooltip></div>)}{drop.raters_count > 5 && <div className={`tw-relative tw-h-5 tw-w-5 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-iron-900 tw-ring-1 ${theme.ring} ${theme.text} tw-text-[10px] tw-font-medium hover:tw-scale-110 tw-transition-transform`}>+{drop.raters_count - 5}</div>}</div>;
    $[0] = drop.raters_count;
    $[1] = drop.top_raters;
    $[2] = drop.wave;
    $[3] = hasRaters;
    $[4] = theme.ring;
    $[5] = theme.text;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = `tw-text-sm tw-font-semibold tw-text-iron-50 ${theme.text}`;
  let t3;
  if ($[7] !== drop.raters_count || $[8] !== t2) {
    t3 = <span className={t2}>{drop.raters_count}</span>;
    $[7] = drop.raters_count;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-sm tw-font-normal tw-text-iron-500">Voters</span>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <span>{t3}{" "}{t4}</span>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t1}{t5}</div>;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}